import { SnapStyleAPIClient } from "./api-client";

/**
 * Manages photo uploads. Returns data rather than manipulating DOM directly.
 */
export class PhotoManager {
    private client: SnapStyleAPIClient;

    constructor(client: SnapStyleAPIClient) {
        this.client = client;
    }

    /**
     * Reads a file and returns a base64 data URL for preview.
     */
    getPreviewDataUrl(file: File): Promise<string> {
        const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
        if (file.size > MAX_FILE_SIZE) {
            return Promise.reject(new Error("File is too large. Please select an image under 10MB."));
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result;
                if (typeof result === "string") {
                    resolve(result);
                } else {
                    reject(new Error("Failed to read file as data URL"));
                }
            };
            reader.onerror = () => reject(new Error("Failed to read file"));
            reader.readAsDataURL(file);
        });
    }

    /**
     * Uploads a photo file to the API. Returns the photo object.
     */
    async uploadPhoto(file: File): Promise<{ id: string; storageUrl: string }> {
        const photo = await this.client.uploadPhoto(file);
        return { id: photo.id, storageUrl: photo.storageUrl };
    }
}
